export const SET_RECEIPTS='SET_RECEIPTS';

